import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import { Modal, Box, Typography } from '@mui/material';

import EditProposta from './EditProposta';
import EditFluxo from './EditFluxo';
import EditFluxoSemAcesso from './EditFluxoSemAcesso';
import DimensionamentoBombeamento from './DimensionamentoBombeamento';
import DimensionamentoOffGrid from './DimensionamentoOffGrid';

// api
import {
  getModulos, getTipoDisjuntores, getPotenciaDisjuntores,
  getFluxogramas, getFornecedores, updateProposta,
} from './api';

// ----------------------------------------------------------------------
// eslint-disable-next-line
const AddProposta = React.forwardRef((props, ref) => {

  const [proposta, setProposta] = useState(null);
  const [etapaBomb, setEtapaBomb] = useState('dimensionamento');
  const [etapaOffGrid, setEtapaOffGrid] = useState('dimensionamento');
  const [salvandoDim, setSalvandoDim] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const modulodData          = await getModulos();
    const tipodisjuntorData    = await getTipoDisjuntores();
    const potenciadisjuntorData = await getPotenciaDisjuntores();
    const fluxogramasData      = await getFluxogramas();
    const fornecedoresData     = await getFornecedores();

    // Sempre usar o fluxo 'Vendas' (id=1) como padrão
    const fluxoVendas = fluxogramasData.find(f => f.id === 1)
      || fluxogramasData.find(f => f.nome === 'Vendas')
      || fluxogramasData[0];

    const emptyProposta = {
      produto: { _id: null },
      fluxo:  fluxoVendas,
      etapa:  fluxoVendas.etapas[0],
      cliente: null,
      localinstalacao: null,
      orientacaotelhado: null,
      disjuntorcliente: {
        tipodisjuntor:    tipodisjuntorData[0],
        potenciadisjuntor: potenciadisjuntorData[0],
      },
      faturas: [],
      mediaconsumo: 0,
      mediaconsumoabatida: 0,
      tarifaEnergia: '',
      distribuidora: null,
      modulo: null,
      fornecedor: fornecedoresData[0],
      kit: null,
      valorkit: 0,
      desconto: 0,
      acrescimo: 0,
      valor: 0,
      data: new Date(),
      user: JSON.parse(localStorage.getItem('userData')),
      origem: null,
      finalizado: null,
      negociacao: null,
      responsavel: null,
      obs: '',
      valorprojeto: 0,
      datainstalacao: new Date(),
      quantidadepaineis: null,
      dataagendamento: new Date(),
      atividades: [],
      backlog: [],
      unidade: null,
      // bombeamento
      dadosBombeamento: null,
      dimensionamentoBomb: null,
      // off-grid
      dadosOffGrid: null,
      dimensionamentoOffGrid: null,
    };

    if (!props.proposta) {
      setProposta(emptyProposta);
    } else {
      setProposta(props.proposta);
    }
    setDataFetched(true);
  };

  useEffect(() => {
    if (props.proposta) {
      setProposta(props.proposta);

      const isLead = props.proposta?.finalizadoLead?.nome === 'Lead Qualificado';

      // Bombeamento: se já dimensionado OU vem de lead, vai direto para proposta
      const db = props.proposta?.dadosBombeamento;
      const temDimBomb = db && (db.potenciaMotorCV || db.alturaManometrica || db.horasFuncionamento);
      if (temDimBomb || isLead) setEtapaBomb('proposta');

      // Off-Grid: se já dimensionado OU vem de lead, vai direto para proposta
      const dog = props.proposta?.dimensionamentoOffGrid;
      const temDimOG = dog && dog.mediaMensal;
      if (temDimOG || isLead) setEtapaOffGrid('proposta');
    }
  }, [props.proposta]);

  // ── Bombeamento novo (sem dimensionamento) ────────────────────────────────
  const isBombeamentoNovo = (
    proposta &&
    proposta?.produto?.nome === 'Sistema de Bombeamento' &&
    !proposta?.dimensionamentoBomb?.meses?.length &&
    etapaBomb === 'dimensionamento'
  );

  // ── Off-Grid novo (sem dimensionamento) ──────────────────────────────────
  const isOffGridNovo = (
    proposta &&
    proposta?.produto?.nome === 'Gerador Off-Grid' &&
    !proposta?.dimensionamentoOffGrid?.mediaMensal &&
    etapaOffGrid === 'dimensionamento'
  );

  console.log('AddProposta render:', {
    produto: proposta?.produto?.nome,
    fluxoId: proposta?.fluxo?.id,
    temDimOG: !!proposta?.dimensionamentoOffGrid?.mediaMensal,
    etapaOffGrid,
    isOffGridNovo,
  });

  // ── Handlers de dimensionamento ───────────────────────────────────────────
  const handleDimensionadoBomb = async (dados) => {
    setSalvandoDim(true);
    const propostaAtualizada = {
      ...proposta,
      kit:                 dados.kitSelecionado,
      modulo:              dados.kitSelecionado?.modulo || proposta.modulo,
      fornecedor:          dados.inputs.fornecedor || proposta.fornecedor,
      valorkit:            dados.kitSelecionado?.precovenda || 0,
      valor:               dados.kitSelecionado?.precovenda || 0,
      mediaconsumo:        dados.dimensionamento.mediaMensal,
      dadosBombeamento:    dados.inputs,
      dimensionamentoBomb: dados.dimensionamento,
      pr:                  dados.dimensionamento.rendFV,
    };
    try {
      const result = await updateProposta(propostaAtualizada);
      const propostaSalva = result?.data || propostaAtualizada;
      setProposta(propostaSalva);
    } catch(e) {
      setProposta(propostaAtualizada);
    }
    setEtapaBomb('proposta');
    setSalvandoDim(false);
  };

  const handleDimensionadoOffGrid = async (dados) => {
    setSalvandoDim(true);
    console.log('handleDimensionadoOffGrid chamado:', { mediaMensal: dados.mediaMensal, proposta_id: proposta?._id });
    const propostaAtualizada = {
      ...proposta,
      mediaconsumo:           dados.mediaMensal || 0,
      mediaconsumoabatida:    0,
      dadosOffGrid:           dados,
      dimensionamentoOffGrid: dados,
      pr:                    dados.pr,
      etapa:                  { id: 2, nome: 'Revisão', color: 'LightYellow' },
    };
    try {
      console.log('Chamando updateProposta...');
      const result = await updateProposta(propostaAtualizada);
      console.log('updateProposta result:', result);
      const propostaSalva = result?.data || propostaAtualizada;
      setProposta(propostaSalva);
    } catch(e) {
      console.error('Erro no updateProposta:', e);
      setProposta(propostaAtualizada);
    }
    setEtapaOffGrid('proposta');
    setSalvandoDim(false);
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        {/* Aguarda fetchData terminar antes de renderizar */}
        {salvandoDim ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh' }}>
            <Typography variant="h6" color="white">Salvando dimensionamento...</Typography>
          </Box>

        ) : !dataFetched ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh' }}>
            <Typography variant="h6" color="white">Carregando...</Typography>
          </Box>

        ) : isBombeamentoNovo ? (
          /* ── Dimensionamento de Bombeamento ── */
          <DimensionamentoBombeamento
            proposta={proposta}
            onVoltar={props.onClose}
            onDimensionado={handleDimensionadoBomb}
          />

        ) : isOffGridNovo ? (
          /* ── Dimensionamento Off-Grid ── */
          <DimensionamentoOffGrid
            proposta={proposta}
            onVoltar={props.onClose}
            onDimensionado={handleDimensionadoOffGrid}
          />

        ) : (
          // log temporário
          console.log('AddProposta: caiu no else - fluxo:', proposta?.fluxo?.id, 'produto:', proposta?.produto?.nome) ||
          // Proposta nova sem produto selecionado → EditProposta para escolher produto
          proposta && !proposta?.produto?._id ?
            <EditProposta open={props.open} proposta={proposta} onClose={props.onClose} onConfirm={props.onConfirm} onSave={props.onSave} />

          // Fluxo Vendas (id=1) ou Lead (id=10) com produto → EditProposta
          : proposta && (proposta?.fluxo?.id === 1 || proposta?.fluxo?.id === 10) && proposta?.produto?._id ?
            <EditProposta open={props.open} proposta={proposta} onClose={props.onClose} onConfirm={props.onConfirm} onSave={props.onSave} />

          : (
            proposta && ([2, 80, 90].includes(proposta.fluxo.id)) ?
              (props.open && <EditFluxo open={props.open} proposta={proposta} onClose={props.onClose} onConfirm={props.onConfirm} onSave={props.onSave} />)
            : proposta && ([3, 100000000].includes(proposta.fluxo.id) && (usuarioLogado.supervisor || usuarioLogado.modulos?.some(m => m.id === 2 && m.ativo === true))) ?
              (props.open && <EditFluxo open={props.open} proposta={proposta} onClose={props.onClose} onConfirm={props.onConfirm} onSave={props.onSave} />)
            : proposta && ([4, 5, 6].includes(proposta.fluxo.id) && (usuarioLogado.supervisor || usuarioLogado.modulos?.some(m => m.id === 3 && m.ativo === true))) ?
              (props.open && <EditFluxo open={props.open} proposta={proposta} onClose={props.onClose} onConfirm={props.onConfirm} onSave={props.onSave} />)
            : <EditFluxoSemAcesso onClose={props.onClose} />
          )
        )}
      </>
    </Modal>
  );
});

AddProposta.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default AddProposta;
